/*
 * Copyright © 2020-2022 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: yongqiang
 * @LastEditTime: 2025-10-27 16:11:14
 */
import React, { ReactElement } from 'react'
import {
  useAppDispatch,
  useAppSelector,
  useVip,
  useAgentCustomerDrawer
} from '../../../app/hooks'
import CONFIG from '../../../constants/config'
import desktopLib from '../../../utils/desktopLib'
import {
  fetchContacUsParams,
  fetchUdeskSign,
  reportContactUs
} from '../../../actions/main'

interface IContactUS {
  style?: React.CSSProperties
  children: ReactElement
  fromPage: string
  artificial?: boolean
  accessId?: string
  track?: () => void
}

const getRole = (roleId) => {
  const item = CONFIG.memberRoles.find(({ id }) => id === roleId)

  return item?.role
}

const ContactUS: React.FC<IContactUS> = ({
  style,
  children,
  fromPage,
  artificial = false,
  accessId = 'fb4bf1ee-15ba-43b9-a0b4-fe6a56fc9514',
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  track = () => {}
}) => {
  const user = useAppSelector((store) => store.main.user)
  const group = useAppSelector((store) => store.group)
  const dispatch = useAppDispatch()
  const customerAgentDrawer = useAgentCustomerDrawer()

  const openContact = async () => {
    track()

    // 上报进线数据
    dispatch(reportContactUs())

    const url = 'https://webchat-sh.clink.cn/chat.html'

    const query = {
      accessId, // 采用人工客服的accessId
      language: 'zh_CN',
      visitorId: user && user?.user_id,
      visitorName: user && user?.nickname,
      tel: user && user?.mobile,
      visitorExtraInfo: '',
      customerFields: '',
      fromPage
    }

    const visitorExtraInfo = {
      版本号: desktopLib.isDesktop ? desktopLib.clientInfo.version : '',
      来源页面: `${desktopLib.isDesktop ? 'PC端' : 'WEB端'}工作圈管理后台`,
      userid: user && user?.user_id,
      姓名: user && user?.nickname,
      登陆手机号: user && user?.mobile,
      团队名称: group.groupName,
      团队号: group.groupId,
      团队会员状态: group.isVip
    }
    try {
      const stat = await dispatch(fetchContacUsParams())

      visitorExtraInfo['个人会员历史充值次数'] = stat.userStats.orderRecordCount
      visitorExtraInfo['个人会员历史充值金额'] =
        stat.userStats.orderRecordSumAmount
      visitorExtraInfo['团队会员历史充值次数'] =
        stat.groupStats.orderRecordCount
      visitorExtraInfo['团队会员历史充值金额'] =
        stat.groupStats.orderRecordSumAmount
    } catch (e) {
      console.log(e)
    }

    query.visitorExtraInfo = JSON.stringify(visitorExtraInfo)
    query.customerFields = JSON.stringify(visitorExtraInfo)

    const qs = Object.entries(query)
      .map(([k, v]) => `${k}=${encodeURIComponent(String(v || ''))}`)
      .join('&')

    if (artificial) {
      // 人工客服
      const contactUrl = `${url}?${qs}`

      if (desktopLib.isDesktop) {
        desktopLib.openContact(contactUrl)
      } else {
        window.open(
          contactUrl,
          '_blank',
          `width=500,height=600,left=${
            (window.screen.availWidth - 500) / 2
          },top=${(window.screen.availHeight - 600) / 2})}`
        )
      }
    } else {
      // Agent客服，打开抽屉并传入 qs 参数
      setTimeout(() => {
        customerAgentDrawer.open({ qs: qs })
      }, 100)
    }
  }

  return (
    <div onClick={openContact} style={{ ...style, cursor: 'pointer' }}>
      {children}
    </div>
  )
}

export default ContactUS
